module.exports = __webpack_public_path__ + "static/media/34.d70c7604.png";